import React from 'react'
import { Route, Routes } from 'react-router'

import { DrawerContainer } from '~/components/features/DrawerContainer'
import { PrivateTopPage } from '~/pages/PrivateTopPage'
import { RestorePage } from '~/pages/RestorePage'

import { resolve } from '../../paths'

import { AppRoot } from './AppRoot'
import { InitialTasks } from './InitialTasks'

export const Authenticated = () => (
  <InitialTasks>
    <DrawerContainer>
      <Routes>
        <Route element={<PrivateTopPage />} path={resolve('top')} />

        <Route element={<RestorePage />} path={resolve('restore')} />

        <Route element={<AppRoot />} path={resolve('appRoot')} />
      </Routes>
    </DrawerContainer>
  </InitialTasks>
)
